import { Injectable, inject } from '@angular/core';
import moment, { Moment } from 'moment';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class tools {

  constructor() { }

  public compareArray(obj1: any[], obj2: any[]): boolean {
    if (obj1.length != obj2.length)
      return false;
    for (let i = 0; i < obj1.length; i++) {
      if (obj1[i] != obj2[i])
        return false;
    }
    return true;
  }

  public sortFileAsAsNumber(object: any): any {
    object.sort((a: any, b: any) => {
      const reg = new RegExp('^[0-9\.]+$');
      if (reg.test(a.fileAs) && reg.test(b.fileAs)) {
        let afileAs: string[] = []
        let bfileAs: string[] = []
        afileAs = a.fileAs.split(".")
        bfileAs = b.fileAs.split(".")
        for (let i = 0; i < afileAs.length; i++) {
          afileAs[i] = afileAs[i].padStart(4, '0')
        }
        for (let i = 0; i < bfileAs.length; i++) {
          bfileAs[i] = bfileAs[i].padStart(4, '0')
        }

        let aPaddedStart = afileAs.join(".")
        let bPaddedStart = bfileAs.join(".")
        return aPaddedStart > bPaddedStart ? 1 : -1
      }
      else
        return a.fileAs > b.fileAs ? 1 : -1
    });
    return object
  }

  public guid(asDash?: boolean) {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    if (asDash != null && asDash == false)
      return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
    else
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  public delay(ms: number): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      setTimeout(resolve, ms)
    })

    return promise
  }

  public delayObservable(ms: number): Observable<any> {
    let promise = new Promise((resolve, reject) => {
      setTimeout(resolve, ms)
    })
    return from(promise)
  }

  public timeParser(duration: number): string {
    if (duration == undefined) return '';
    let strReturn = '';
    let days: number = 0;
    let minutes = 0;
    let hours = 0;
    let secondes = 0;

    secondes = Math.floor(duration % 60);
    minutes = Math.floor((duration / 60) % 60);
    hours = Math.floor((duration / (60 * 60)) % 24);
    days = Math.floor(duration / (60 * 60 * 24));

    let hoursStr = hours < 10 ? '0' + hours : hours;
    let minutesStr = minutes < 10 ? '0' + minutes : minutes;
    let daysStr = days.toString();
    if (days > 0) strReturn += daysStr + 'j ';
    if (days > 0 || hours > 0) strReturn += hoursStr + 'h';
    if (minutes > 0) strReturn += minutesStr + 'm';
    if (secondes > 0) strReturn += secondes + 's';

    if (strReturn == '') return '0';
    else return strReturn;
  }

  public getIsoDate(date: Date | string | Moment): string | null {
    if (typeof date == 'string') {
      if (date.length > 1) {
        let dateStr = new Date(date);
        let month = dateStr.getMonth() + 1;
        let monthStr = ('0' + month).slice(-2);
        let dayNumber = ('0' + dateStr.getDate()).slice(-2);
        return dateStr.getFullYear() + '-' + monthStr + '-' + dayNumber;
      } else return null;
    } else if (date instanceof Date) {
      let month = date.getMonth() + 1;
      let monthStr = ('0' + month).slice(-2);
      let dayNumber = ('0' + date.getDate()).slice(-2);
      return date.getFullYear() + '-' + monthStr + '-' + dayNumber;
    } else if (date instanceof moment) {
      let dateStr = date.toDate();
      let month = dateStr.getMonth() + 1;
      let monthStr = ('0' + month).slice(-2);
      let dayNumber = ('0' + dateStr.getDate()).slice(-2);
      return dateStr.getFullYear() + '-' + monthStr + '-' + dayNumber;
    } else return null;
  }

  //remove char given in input from a string if it exist at the beginin and at the end
  public trimChar(path: string, char: string): string {
    if (path == undefined || path == "") return "";
    if (path.charAt(0) == char) { path = path.substring(1); }
    if (path.charAt(path.length - 1) == char) { path = path.substring(0, path.length - 1); }
    return path;
  }

  public logs(log?: any, ...optionalParams: any[]): void {
    console.log(window.location);
    console.log(log, optionalParams);
  }

  public strMapToObj(obj: any) {
    let strMap = new Map();
    for (let k of Object.keys(obj)) {
      strMap.set(k, obj[k]);
    }
    return strMap;
  }

  public stringToColor(str: string): string {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var color = '#';
    for (var i = 0; i < 3; i++) {
      var value = (hash >> (i * 8)) & 0xFF;
      color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
  }

  public stringToHslColor(str: string, s: number = 60, l: number = 70): any { //generate colors from pseudo trigram string
    var hash = 0;
    for (var i = 0; i < str?.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var h = hash % 360;
    return { h: h, s: s, l: l };
  }

  public hslColorAsString(hsl: any): string {
    return 'hsl(' + hsl.h + ', ' + hsl.s + '%, ' + hsl.l + '%)';
  }

  public hslToHex(hslBase: any) {
    let hsl = JSON.parse(JSON.stringify(hslBase));
    hsl.l /= 100;
    const a = hsl.s * Math.min(hsl.l, 1 - hsl.l) / 100;
    const f = (n: any) => {
      const k = (n + hsl.h / 30) % 12;
      const color = hsl.l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
  }

  public colorToBlind(baseColor: string, group: colorBlindType): string {
    let convertedColor = baseColor;
    switch (group.type) {
      // case "Achromatomaly":
      //   convertedColor = blinder.Achromatomaly(baseColor, false);
      //   break;
      // case "Achromatopsia":
      //   convertedColor = blinder.Achromatopsia(baseColor, false);
      //   break;
      // case "Deuteranomaly":
      //   convertedColor = blinder.Deuteranomaly(baseColor, false);
      //   break;
      // case "Deuteranopia":
      //   convertedColor = blinder.Deuteranopia(baseColor, false);
      //   break;
      // case "Protanomaly":
      //   convertedColor = blinder.Protanomaly(baseColor, false);
      //   break;
      // case "Protanopia":
      //   convertedColor = blinder.Protanopia(baseColor, false);
      //   break;
      // case "Tritanomaly":
      //   convertedColor = blinder.Tritanomaly(baseColor, false);
      //   break;
      // case "Tritanopia":
      //   convertedColor = blinder.Achromatomaly(baseColor, false);
      //   break;
    }
    return convertedColor;
  }

  public hexToHSL(hex: string): { h: number; s: number; l: number; } {
    //remove transparencyColor
    if (hex.length == 9)
      hex = hex.slice(0, -2);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
      throw new Error("Could not parse Hex Color");
    }
    const rHex = parseInt(result[1], 16);
    const gHex = parseInt(result[2], 16);
    const bHex = parseInt(result[3], 16);
    const r = rHex / 255;
    const g = gHex / 255;
    const b = bHex / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = (max + min) / 2;
    let s = h;
    let l = h;
    if (max === min) {
      // Achromatic
      return { h: 0, s: 0, l };
    }
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
    s = s * 100;
    s = Math.round(s);
    l = l * 100;
    l = Math.round(l);
    h = Math.round(360 * h);
    return { h, s, l };
  }

  private rgbToYIQ({ r, g, b }: any): number {
    return ((r * 299) + (g * 587) + (b * 114)) / 1000;
  }

  private hexToRgb(hex: string): any | undefined {
    if (!hex || hex === undefined || hex === '') {
      return undefined;
    }
    const result: RegExpExecArray | null = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : undefined;
  }

  private rgbToHex(r: any, g: any, b: any) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }


  public contrastColorText(colorHex: string | undefined,
    threshold: number = 128): string {
    if (colorHex === undefined) {
      return '#000';
    }
    const rgb: any | undefined = this.hexToRgb(colorHex);
    if (rgb === undefined) {
      return '#000';
    }
    return this.rgbToYIQ(rgb) >= threshold ? '#000' : '#fff';
  }

  public PercentageToGreenRedColor(percentage: number, opacity: string = "FF"): string // percentage between 0 and 100, return color in hex
  {
    let green: number = (percentage * 2.55);
    let red: number = ((1 - percentage) * 2.55);
    return this.rgbToHex(red, green, 0) + opacity;
  }

  public negativeDecimalColorToHexColor(color: number) //input format see https://stackoverflow.com/questions/42633608/convert-negative-color-numbers-to-hex-or-rgb
  {
    if (color == undefined)
      return "";
    let colorValue = 16777216 + color;
    let colorHex = colorValue.toString(16);
    while (colorHex.length < 6) {
      colorHex = "0" + colorHex;
    }
    return "#" + colorHex;
  }

  public isSafari(): boolean {
    let is_ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent)
    let is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    return is_ios || is_safari
  }

  public isFirefox(): boolean {
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1)
      return true;
    else
      return false;
  }

  public getAncestorOrigins() {
    if (location.ancestorOrigins !== undefined) {
      return document.location.ancestorOrigins;
    }
    const urls = [];
    let parentWin = window;
    while (parentWin !== window.top) {
      if (parentWin.document.referrer) {
        try {
          const url = new URL(parentWin.document.referrer);
          urls.push(url.origin);
        } catch (e) {
          // console.error
        }
      }
      // @ts-ignore
      parentWin = parentWin.parent;
    }
    return urls;
  }

  public windowHasMenuBar(): boolean {
    //In D4 context a window without menuBar is equivalent to a window children
    return window.menubar.visible;
  }

  public isWebKit(): boolean {
    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    if (isChrome || isSafari) {
      return true;
    }
    return false;
  }

  /*
    itmes in array must contain rank object
  */
  public findNextRank(list: any[], rankNameObject: string = "rank"): number {
    let nextRank = 0;
    for (let i = 0; i < list.length; i++) {
      if (list[i][rankNameObject] > nextRank)
        nextRank = list[i][rankNameObject];
    }
    let nextRankCeil = 10 * Math.ceil(nextRank / 10); //arrondie à la dizaine supérieur
    if (nextRankCeil == nextRank)
      nextRank = nextRank + 10;
    else
      nextRank = nextRankCeil;
    return nextRank;
  }

}


export function getBaseLocation() {
  let paths: string[] = location.pathname.split('/').splice(1, 1);
  let basePath: string = (paths && paths[0]) || 'home'; // Default: home
  console.log("return basePath : /" + basePath);
  return '/' + basePath;
}

export interface HashTable<T> {
  [key: string]: T;
}

export interface colorBlindType {
  type: "Protanomaly" | "Achromatopsia" | "Achromatomaly" | "Protanopia" | "Deuteranopia" | "Tritanopia" | "Deuteranomaly" | "Tritanomaly";
}